import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import InfoPage, { InfoSection } from "@/components/InfoPage";
import { COMPANY, CORPORATE_PANTRY_FORM_URL } from "@/data/site";

const Contact = () => (
  <InfoPage
    eyebrow="Contact Us"
    title="We're listening."
    intro="Questions about an order, your subscription or what goes into a DNA bar — write to us and a real person will reply within one working day."
    testId="contact-page"
  >
    <InfoSection heading="Write to us">
      <a href={`mailto:${COMPANY.email}`} className="font-serif-lux text-3xl text-[#111111] hover:text-[#C07C5F] transition-colors duration-300" data-testid="contact-email">
        {COMPANY.email}
      </a>
      {COMPANY.phone && (
        <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="font-serif-lux text-2xl text-[#111111] hover:text-[#C07C5F] transition-colors duration-300" data-testid="contact-phone">
          {COMPANY.phone}
        </a>
      )}
      <p>{COMPANY.hours}</p>
    </InfoSection>

    <InfoSection heading="Order help">
      <p>
        Include your order number (it starts with <span className="text-[#111111]">DNA</span>) and we can help faster.
        You can track every order from <Link to="/account" className="text-[#C07C5F] underline underline-offset-4">My Account</Link>.
      </p>
    </InfoSection>

    <InfoSection heading="Corporate pantry">
      <p>Stocking DNA bars for your office, gym or team? Tell us about it and we'll put together a pantry plan.</p>
      {CORPORATE_PANTRY_FORM_URL ? (
        <a href={CORPORATE_PANTRY_FORM_URL} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-[#C07C5F] uppercase text-[11px] tracking-[0.3em]">
          Enquire now <ArrowUpRight size={12} />
        </a>
      ) : (
        <a href={`mailto:${COMPANY.email}?subject=Corporate%20Pantry%20Enquiry`} className="flex items-center gap-1 text-[#C07C5F] uppercase text-[11px] tracking-[0.3em]">
          Email us <ArrowUpRight size={12} />
        </a>
      )}
    </InfoSection>

    <InfoSection heading="Registered office">
      <p>
        <span className="text-[#111111]">{COMPANY.legalName}</span>
        <br />
        CIN: {COMPANY.cin}
        <br />
        {COMPANY.address[0]}
        <br />
        {COMPANY.address[1]}
      </p>
    </InfoSection>
  </InfoPage>
);

export default Contact;
